module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_04_sp-41db0e1c3b6a021c44db44a710fe524a.png";